export const generateStoreLink = (isIOSDevice: boolean, code?: string) => {
  if (!code) return '#';

  if (isIOSDevice) {
    return `https://apps.apple.com/redeem?ctx=offercodes&id=1513137174&code=${code}`;
  }

  return `https://play.google.com/redeem?code=${code}`;
};
